import React from "react";
import { requireAuth } from "../util/auth.js";
import AddCoffeeSection from "./../components/AddCoffeeSection";


function AddCoffeePage(props) {
    return (
      <AddCoffeeSection
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="Add Coffee"
      subtitle=""
      buttonText="Add"
      buttonColor="primary"
      showNameField={true}
      inputSize="md"
    />
  );
}

export default requireAuth(AddCoffeePage);